/* eslint-disable max-len */
import React from 'react'

export const MagnifyingGlass = () => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8717 7.43583C12.8717 10.438 10.438 12.8717 7.43583 12.8717C4.43371 12.8717 2 10.438 2 7.43583C2 4.43371 4.43371 2 7.43583 2C10.438 2 12.8717 4.43371 12.8717 7.43583ZM11.9392 13.3534C10.6893 14.306 9.12863 14.8717 7.43583 14.8717C3.32914 14.8717 0 11.5425 0 7.43583C0 3.32914 3.32914 0 7.43583 0C11.5425 0 14.8717 3.32914 14.8717 7.43583C14.8717 9.12863 14.306 10.6893 13.3534 11.9392L20.1229 18.7087L18.7087 20.1229L11.9392 13.3534Z"
      fill="inherit"
    />
  </svg>
)
